(function () {
    'use strict';
    angular.module('components.api', [
        'utils']);
})();